import { Navigate, useSearchParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useAuthStore } from 'app/stores/StoreContext'
import { useSettingsAvailability } from 'app/components/settings-availability/useSettingsAvailability'
import { SettingsAvailabilityShadcnComponent } from 'app/components/settings-availability/SettingsAvailabilityShadcnComponent'

const REQUIRED_PRODUCTS = [`Scheduler`, `AI Agent`, `SMS Agent`]

// observer: reads authStore.products and the store-backed locations list in render.
// Both can change in place (workspace switch reassigns products; the locations list
// loads asynchronously), so without observer the gate and single-location redirect
// would not react (TRK-6020).
const AvailabilityIndex = observer(function AvailabilityIndex(): React.ReactElement {
  const { products } = useAuthStore()
  const [searchParams] = useSearchParams()
  const { locations, columns, loading } = useSettingsAvailability()

  const hasRequiredProduct = products?.some((p) => REQUIRED_PRODUCTS.includes(p)) ?? false

  const onlyLocation = !loading && !searchParams.get(`query`) && locations.total === 1 ? locations.hits[0] : undefined

  if (products && !hasRequiredProduct) {
    return <Navigate to="/settings" replace />
  }

  if (onlyLocation?.id) {
    return <Navigate to={`${onlyLocation.id}/settings`} replace />
  }

  return <SettingsAvailabilityShadcnComponent locations={locations} columns={columns} />
})

export default AvailabilityIndex
